import { createContext, useRef, useState } from "react";
import reqColaborador from "../../../../services/reqMultiTenant/reqColaborador";

const ContextRegisterCollaborator = createContext({});

function RegisterCollaboratorProvider(props) {
	// Controle Modal
	const [isOpenModalFilterCollaborator, setIsOpenModalFilterCollaborator] = useState(false);
	const [isOpenModalRegisterCollaborator, setIsOpenModalRegisterCollaborator] = useState(false);
	const [isOpenModalRecoveryCollaborator, setIsOpenModalRecoveryCollaborator] = useState(false);

	//Dados do cliente
	const [id_funcionario, setId_Funcionario] = useState(0);
	const [collaboratorData, setCollaboratorData] = useState([]);
	const [collaboratorRecovery, setCollaboratorRecovery] = useState({});
	const [filterData, setFilterData] = useState({});

	//Controle de paginação
	const [page, setPage] = useState(1);
	const [totalPage, setTotalPage] = useState(0);
	const currentPage = useRef(0);

	const [loading, setLoading] = useState(false);

	const openModalFilterCollaborator = () => {
		setIsOpenModalFilterCollaborator((prevState) => !prevState);
	};

	const openModalRegisterCollaborator = (item) => {
		let id = 0;

		if (item?.id_funcionario) id = item.id_funcionario;

		setId_Funcionario(id);

		setIsOpenModalRegisterCollaborator(true);
	};

	const closeModalRegisterCollaborator = () => {
		setIsOpenModalRegisterCollaborator(false);
	};

	const openModalRecoveryCollaborator = (item) => {
		setCollaboratorRecovery(item);
		setIsOpenModalRecoveryCollaborator(true);
	};

	const closeModalRecoveryCollaborator = () => {
		setIsOpenModalRecoveryCollaborator(false);
	};

	// busca o resultado completo da pesquisa (mesmos filtros), sem paginação, usado para gerar o relatório
	const fetchAllCollaborators = async () => {
		const { param, paramValue, ativo } = filterData;

		const response = await reqColaborador.listPaginate(param, paramValue, ativo, 1, 100000);
		return response?.data || [];
	};

	const fetchCollaboratorPage = async () => {
		setLoading(true);
		try {
			try {
				const { param, paramValue, active } = filterData;

				let ativo = "NAO";
				if (active === true) ativo = "SIM";

				const response = await reqColaborador.listPaginate(param, paramValue, ativo, currentPage.current + 1);

				setCollaboratorData((prevData) => [...prevData, ...response.data]);

				//se não encontrou nada esta na ultima pagina
				if (response.data.length < 15) {
					setTotalPage(currentPage.current + 1);
				}

				if (response.data.length !== 0) currentPage.current++;
			} catch (error) {
				setCollaboratorData([]);
				// Notification.showToast({ message: error.message, type: "warning" });
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<ContextRegisterCollaborator.Provider
			value={{
				openModalFilterCollaborator,
				id_funcionario,
				openModalRegisterCollaborator,
				closeModalRegisterCollaborator,
				isOpenModalFilterCollaborator,
				isOpenModalRegisterCollaborator,
				isOpenModalRecoveryCollaborator,
				openModalRecoveryCollaborator,
				closeModalRecoveryCollaborator,
				collaboratorRecovery,
				setCollaboratorData,
				setFilterData,
				filterData,
				collaboratorData,
				page,
				totalPage,
				setPage,
				setTotalPage,
				loading,
				setLoading,
				currentPage,
				fetchCollaboratorPage,
				fetchAllCollaborators,
			}}
		>
			{props.children}
		</ContextRegisterCollaborator.Provider>
	);
}

export { ContextRegisterCollaborator, RegisterCollaboratorProvider };
